// primary
export const primary_turquoise_500 = "#04D2C5";
export const primary_purple_500 = "#6848FF";

// netural
export const netural_grey_100 = "#FBFCFE";
export const netural_grey_200 = "#F0F3F8";
export const netural_grey_300 = "#e2e8f0";
export const netural_grey_500 = "#b7c0cc";
export const netural_grey_800 = "#404753";
export const netural_grey_900 = "#191E27";

// secondary
export const secondary_red_500 = "#EE4444";
export const secondary_green_500 = "#4CAF50";
export const secondary_blue_100 = "#eff5fb";
export const secondary_blue_500 = "#1f70c7";

// text
export const text_light_major = "#fff";
export const text_dark_major = "#1e2134";
export const text_dark_minor = "#506176";
export const text_dark_accessory = "#a1a8b3";
